import { createIcon } from "@chakra-ui/icons";

export const FullscreenIcon = createIcon({
  displayName: "Fullscreen",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M3 3h6v2H5v4H3V3zm12 0h6v6h-2V5h-4V3zM3 15h2v4h4v2H3v-6zm16 4h-4v2h6v-6h-2v4z"
    />
  ),
});

export const ExitFullscreenIcon = createIcon({
  displayName: "ExitFullscreen",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
    />
  ),
});
